import { Api } from '@/services/Api'
import store from "@/store/index";
const momentTz = require('moment-timezone')

export default {
  getTotalGeneration (plantId, model) {
    return Api().get(`/api/v2/forecast/totalGen/${plantId}/${model}`)
  },
  getWeatherData (plantId) {
    return Api().get(`/api/v2/forecast/forecastWeather/${plantId}`)
  },
  getPenaltyTrendData (plantId) {
    return Api().get(`/api/v2/forecast/penalty/${plantId}`)
  },
  getDeviationCountData (plantId, dateFrom, dateTo, model) {
    return Api().get(`/api/v2/forecast/deviation/${plantId}/${dateFrom}/${dateTo}/${model}`)
  },
  getPenaltyVsGenerationData(plantId, dateFrom, dateTo) {
    return Api().get(`/api/v2/forecast/generationPenalty/${plantId}/${dateFrom}/${dateTo}`)
  },
  getRevisionData(plantId, dateFrom, dateTo) {
    return Api().get(`/api/v2/forecast/revisions/${plantId}/${dateFrom}/${dateTo}`)
  },
  postRevision(payload) {
    return Api().post('/api/v2/forecast/revisions', payload)
  },
  getSummaryData(plantId, dateFrom, dateTo, model) {
    return Api().get(`/api/v2/forecast/summary/${plantId}/${dateFrom}/${dateTo}/${model}`)
  },
  getGraphData(plantId, dateFrom, dateTo, model) {
    return Api().get(`/api/v2/forecast/graph/${plantId}/${dateFrom}/${dateTo}/${model}`)
  },
  download(param) {
    return Api().request({
      url: '/api/v2/forecast/download/' + param,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const tz = store.getters.getGeneralState('activePlant').timezone
      const filename = `${momentTz().tz(tz).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
  }
}
